"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useShortcut;

var _react = require("react");

function useShortcut(targetKey, handler) {
  let isKeyPressed = {}; // If pressed key is our target key then set to true

  function arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  }

  function downHandler(event) {
    isKeyPressed[event.key] = true;

    if (arraysEqual(Object.keys(isKeyPressed), targetKey)) {
      handler();
      isKeyPressed = {};
    }
  }

  function clearKeysPressed(event) {
    delete isKeyPressed[event.key];
  } // Add event listeners


  (0, _react.useEffect)(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", clearKeysPressed); // Remove event listeners on cleanup

    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount
}